// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, takeLatest } from 'redux-saga/effects';
import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import { saveCustomerServiceLocationAddressSuccess, SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS } from './../../../store/orderCreation';

function* saveCustomerServiceLocationAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS,
            })
        );

        yield put(saveCustomerServiceLocationAddressSuccess(request.payload));

        yield put(
            actionStatusSuccess({
                actionName: SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS,
            })
        );
    } catch (e) {
        yield yield put(
            actionStatusFailed({
                actionName: SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS,
                error: e,
            })
        );
    }
}

export default [takeLatest(SAVE_CUSTOMER_SERVICE_LOCATION_ADDRESS, saveCustomerServiceLocationAddress)];
